/*global Handlebars*/
define('handlebarsHelper', ['jquery', 'handlebars'], function($, Handlebars) {
	Handlebars.registerHelper('rawHTML', function(s) {
		return s;
	});

	Handlebars.registerHelper('toLowerCase', function(value) {
		return (value && typeof value === 'string') ? value.toLowerCase() : '';
	});

	/*
		Registered helper that allows the use of limited if / else logic within the handlebars template
	*/

	Handlebars.registerHelper('if_eq', function(context, options) {
		var match = false;

		$.each(options.hash.compare.split("|"), function(index, value) {

			value = value.toString();
			context = (context ? context.toString() : '');

			if (context === value){
				match = true;
			}
		});

		if (match === true){
			return options.fn(this);
		} else {
			return options.inverse(this);
		}
	});

	Handlebars.registerHelper('if_gt', function(context, options) {
		if (context > options.hash.compare)
			return options.fn(this);
		return options.inverse(this);
	});

	Handlebars.registerHelper('if_match', function(context, options) {
		options.hash.compare = new RegExp(options.hash.compare, "gi");
		return (options.hash.compare.test(context) ? options.fn(this) : '');
	});

	Handlebars.registerHelper('if_not_match', function(context, options) {
		options.hash.compare = new RegExp(options.hash.compare, "gi");
		return (!options.hash.compare.test(context) ? options.fn(this) : '');
	});

	Handlebars.registerHelper('divide_round', function(value) {
		// 100 / 5 => 5 stars is 100% width, so 4 stars are 80% width and so on
		return (Math.round(100 / 5) * value);
	});
});
